import Model from 'models/Model';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import providerListApi from './list/Api.Provider.List';
import providerFindApi from './find/Api.Provider.Find';
import providerSaveApi from './save/Api.Provider.Save';
import providerDeleteApi from './delete/Api.Provider.Delete';
import Product from '../product/Model.Product';

export default class Provider
  extends Model<Model.IProvider>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProvider> {
  id: number;
  code: string;
  name: string;
  amount: number;
  currency: string;
  logoMediaFile?: MediaFile;
  products: Product[];

  constructor(data: Partial<Model.IProvider> | Utils.FormData<Model.IProvider>, language?: Locale.Languages) {
    super({
      logoMediaFile: MediaFile,
      products: [Product]
    }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name || this.id?.toString()
    };
  }

  static async list(body?: Api.Core.Provider.List.IRequest) {
    const { payload, ...rest } = await providerListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new Provider(it)),
        count: payload.count,
      },
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await providerFindApi(params);
    return {
      ...rest,
      payload: payload ? new Provider(payload) : null,
    };
  }
  async save() {
    return await providerSaveApi(this);
  }
  async delete() {
    return await providerDeleteApi(this.id);
  }
}
